export type MenuItem = {
  label: string;
  href: string;
  isExternal: boolean;
};

export type MenuGroup = {
  title: string;
  items: MenuItem[];
};

export const isMenuItem = (item: MenuGroup | MenuItem): item is MenuItem =>
  (item as MenuItem).href !== undefined;

export type MenuGroupProps = {
  group: MenuGroup;
  itemClassName?: string;
  titleClassName?: string;
};
